
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class ContentWithOverlay extends Vue {
    @Prop({ type: String, default: null }) public readonly header!: string | null;
    @Prop({ type: String, default: null }) public readonly subheader!: string | null;
    @Prop({ type: Boolean, default: false }) public readonly rounded!: boolean;
    @Prop({ type: Boolean, default: true }) public readonly showHeader!: boolean;

    public get formattedSubHeader(): string {
        // Ensure first letter is uppercase
        return this.subheader ? this.subheader.charAt(0).toUpperCase() + this.subheader.slice(1) : '';
    }
}
